import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

MultiRetailerOrder.propTypes = {
    isMultiRetailer: PropTypes.bool,
    isNewTraduction: PropTypes.bool
};

function MultiRetailerOrder({isMultiRetailer = false, isNewTraduction = false}) {

    if (isMultiRetailer) {
        if (isNewTraduction) {
            return <b><FormattedMessage id={'picking.order.show.table.order.multiRetailer.new'} /></b>
        }

        return <b><FormattedMessage id={'picking.order.show.table.order.multiRetailer'} /></b>
    }

    return null
}

export default MultiRetailerOrder;
